import { useOutletContext } from 'react-router-dom'

import type { RouteContextParams } from 'modules/custom_resources/lib/RouteContextParams'
import CustomTablePage from 'modules/custom_resources/pages/Customizations/CustomTable'

const IndexPage = () => {
  const { schemaId } = useOutletContext<RouteContextParams>()

  return <CustomTablePage schemaId={schemaId} />
}

export default IndexPage
